module.exports = ({ NPM_RN_CLIENT }) => `// cocoapods
pod 'FlagsmithClient', '~> 1.0.1'
`;
